module.exports = __webpack_public_path__ + "img/2_C.707eef0b.webp";